import {defineMessages} from 'react-intl';

export const navigationMessages = defineMessages({
  close: { id: 'navigation.close' },
  finish: { id: 'navigation.finish' },
  finishClose: { id: 'navigation.finish_close' },
  next: { id: 'navigation.next' },
  previous: { id: 'navigation.previous' },
  continue: { id: 'navigation.continue' },
  done: { id: 'navigation.done' },
  audioOn: {
    id: 'navigation.audio_on',
  },
  audioOff: {
    id: 'navigation.audio_off',
  },
  subtitlesOn: {
    id: 'navigation.subtitles_on',
  },
  subtitlesOff: {
    id: 'navigation.subtitles_off',
  },
});
